<nz-layout>
    <nz-header class="border-none sticky top-0 w-full z-50">
        <app-header/>
    </nz-header>
    <nz-content>
        <div class="m-4">
            <router-outlet></router-outlet>
        </div>
    </nz-content>
</nz-layout>